import React, { useEffect } from 'react';
import './PrivateAlpsDots.css';

const PrivateAlpsDots = ({ 
  dotConfigs = [],
  containerId = "dots-container",
  animationEnabled = true 
}) => {
  
  useEffect(() => {
    if (!animationEnabled) return;
    
    // Animation logic for dots
    const dots = document.querySelectorAll('._oneDot_ryo35_9');
    
    const animateDots = () => {
      dots.forEach((dot, index) => {
        const delay = index * 100;
        setTimeout(() => {
          if (Math.random() > 0.7) {
            dot.setAttribute('data-active', 'true');
            setTimeout(() => {
              dot.removeAttribute('data-active');
            }, 2000 + Math.random() * 3000);
          }
        }, delay);
      });
    };

    // Initial animation
    setTimeout(animateDots, 1000);
    
    // Repeat animation
    const interval = setInterval(animateDots, 8000);
    
    return () => clearInterval(interval);
  }, [animationEnabled]);

  return (
    <div className="_dots_ryo35_1" id={containerId}>
      {dotConfigs.map((dot, index) => (
        <div
          key={index}
          className="_oneDot_ryo35_9"
          style={{
            top: dot.top,
            left: dot.left,
            right: dot.right,
            bottom: dot.bottom
          }}
          data-type={dot.type || "empty"}
          data-active={dot.active || undefined}
        />
      ))}
    </div>
  );
};

// Predefined dot configurations for different sections
export const heroDotsConfig = [
  { top: '15%', left: '10%', type: 'empty' },
  { top: '20%', left: '15%', active: true },
  { top: '25%', left: '12%', type: 'empty' },
  { top: '30%', left: '18%', active: true },
  { top: '18%', right: '8%', type: 'empty' },
  { top: '22%', right: '12%', active: true },
  { top: '28%', right: '10%', type: 'empty' },
  { top: '35%', right: '15%', active: true },
];

export const voiceBoxDotsConfig = [
  { top: '45%', left: '25%', active: true },
  { top: '48%', left: '22%', type: 'empty' },
  { top: '52%', left: '28%', type: 'empty' },
  { top: '55%', left: '25%', active: true },
  { top: '47%', right: '22%', type: 'empty' },
  { top: '51%', right: '25%', active: true },
  { top: '54%', right: '23%', type: 'empty' },
  { top: '58%', right: '28%', active: true },
];

export const howItWorksDotsConfig = [
  { top: '70%', left: '5%', active: true },
  { top: '75%', left: '8%', type: 'empty' },
  { top: '80%', left: '6%', type: 'empty' },
  { top: '85%', left: '10%', active: true },
  { top: '72%', right: '6%', type: 'empty' },
  { top: '77%', right: '9%', active: true },
  { top: '82%', right: '7%', type: 'empty' },
  { top: '87%', right: '11%', active: true },
];

export const edgeDotsConfig = [
  { top: '10%', left: '2%', active: true },
  { top: '15%', left: '5%', type: 'empty' },
  { top: '12%', right: '3%', type: 'empty' },
  { top: '17%', right: '6%', active: true },
  { top: '90%', left: '3%', type: 'empty' },
  { top: '93%', left: '6%', active: true },
  { top: '91%', right: '4%', active: true },
  { top: '94%', right: '7%', type: 'empty' },
];

export const centerDotsConfig = [
  { top: '35%', left: '50%', type: 'empty' },
  { top: '42%', left: '48%', active: true },
  { top: '65%', left: '52%', type: 'empty' },
  { top: '75%', left: '45%', active: true },
];

// Combined configurations
export const allDotsConfig = [
  ...heroDotsConfig,
  ...voiceBoxDotsConfig,
  ...howItWorksDotsConfig,
  ...edgeDotsConfig,
  ...centerDotsConfig
];

export const pricingDotsConfig = [
  { top: '20%', left: '8%', active: true },
  { top: '25%', left: '12%', type: 'empty' },
  { top: '30%', left: '6%', type: 'empty' },
  { top: '35%', left: '15%', active: true },
  { top: '22%', right: '10%', type: 'empty' },
  { top: '28%', right: '8%', active: true },
  { top: '33%', right: '14%', type: 'empty' },
  { top: '38%', right: '7%', active: true },
  { top: '50%', left: '5%', active: true },
  { top: '55%', left: '10%', type: 'empty' },
  { top: '60%', left: '8%', type: 'empty' },
  { top: '65%', left: '12%', active: true },
  { top: '52%', right: '6%', type: 'empty' },
  { top: '58%', right: '11%', active: true },
  { top: '63%', right: '9%', type: 'empty' },
  { top: '68%', right: '13%', active: true },
];

export default PrivateAlpsDots; 